import { gql } from '@apollo/client';
import { useMutation } from '@tbitop/api';

export const useAufgabeAbschliessen = () => {
  const [executeMutation, { loading, error }] = useMutation(gql`
    mutation AufgabeAbschliessen($id: UUID!, $ergebnis: String!, $ergebnisOption: String!, $kommentar: String) {
      aufgabeAbschliessen(id: $id,ergebnis: $ergebnis, ergebnisOption: $ergebnisOption, kommentar: $kommentar) {
        id,
        ergebnis
        ergebnisOption
        kommentar
        protokoll {
          erstellt
          akteurId
          akteur
          aktion
        }
        status
        objekt {
          id
          aufgabenStatistik {
            anzahl
            status
          }
        }
      }
    }
  `);

  return {
    aufgabeAbschliessen: (id: string, ergebnis: string, ergebnisOption?: string, kommentar?: string) => {
      return executeMutation({
        variables: { id, ergebnis, ergebnisOption, kommentar },
        update(cache, a, b) {
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'offeneAufgabenStatistik' });
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'objekteSeitenweise' });
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'neueObjekteFuerKampagne', broadcast: true });
          // the integration test will fail if we don't evict Aufgabe as well 🤷‍♂️
          cache.evict({ id: `Aufgabe:${id}` });
        },
        refetchQueries: [
          'Objekt',
        ],
      });
    },
    loading,
    error,
  };
};
